module.exports = __webpack_public_path__ + "img/400.ff144dfe.jpg";